<template>
  <div class="index_header">
    <div class="ih_left">
      <a href="/">
        <img src="@/assets/logo.png" alt="" />
      </a>
    </div>

    <div class="ih_right clearfix">
      <div class="search clearfix">
        <div class="search_content">
          <img class="search_img" src="@/assets/search.png" />
          <input
            type="text"
            :placeholder="holderText"
            v-model="searchContent"
            class="input_content"
            @keydown.enter="search()"
            @blur="changeState()"
            @focus="getLinkList()"
            @input="getLinkList()"
          />
          <div class="history_content">
            <ul
              v-if="showHistory || showHistoryDialog"
              @mouseenter="showHistoryDialog = true"
              @mouseleave="showHistoryDialog = false"
            >
              <li class="history_bar">
                搜索历史
                <span @click="removeHistory()">清空</span>
              </li>
              <li
                v-for="item in searchHistory"
                :key="item"
                class="history_item"
              >
                <div class="history_text" @click="search(item)">{{ item }}</div>
                <div class="el-icon-error" @click="removeHistory(item)"></div>
              </li>
            </ul>
            <ul
              v-if="showLink || showLinkDialog"
              @mouseenter="showLinkDialog = true"
              @mouseleave="showLinkDialog = false"
            >
              <li
                v-for="item in linkList"
                :key="item.suggest_text"
                class="suggestion_item"
              >
                <div
                  @click="search(item.suggest_text)"
                  v-html="item.suggest_text"
                  class="suggestion_text"
                ></div>
              </li>
            </ul>
          </div>
        </div>
        <button class="search_button" @click="search()">搜索</button>
      </div>
      <div class="outer_link">
        <!-- <el-link :underline="false" href="http://video-old.kepuchina.cn"
          >点击回到旧网址</el-link
        >
        <div class="divider"></div> -->
        <el-link :underline="false" href="/download" target="_blank"
          >下载APP</el-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getAssocationList, getHotWrods } from "@/api";
export default {
  data() {
    return {
      searchContent: "",
      searchHistory: [],
      showHistory: false,
      showLink: false,
      showHistoryDialog: false,
      showLinkDialog: false,
      linkList: [],
      oldContent: "",
      hotWords: [],
      holderText: "",
      timer: "",
      index: 0,
      isIE: false,
    };
  },
  created() {
    this.searchContent = this.$route.query.name;
    this.getHotWords();
  },

  mounted() {
    this.initPlaceHolder();
  },

  methods: {
    setHistory(searchContent) {
      this.removeHistory(searchContent);
      if (this.searchHistory.length == 10) {
        this.searchHistory.pop();
      }
      this.searchHistory.unshift(searchContent);
      this.saveHistory();
    },

    saveHistory() {
      localStorage.setItem("searchHistory", this.searchHistory.join(","));
    },
    removeHistory(key) {
      if (key) {
        var index = this.searchHistory.indexOf(key, 0);
        if (index > -1) {
          this.searchHistory.splice(index, 1);
        }
        if (this.searchHistory.length == 0) {
          localStorage.removeItem("searchHistory");
          this.showHistory = false;
          this.showHistoryDialog = false;
        } else {
          this.saveHistory();
        }
      } else {
        this.searchHistory.splice(0, this.searchHistory.length);
        localStorage.removeItem("searchHistory");
        this.showHistory = false;
        this.showHistoryDialog = false;
      }
    },
    search(searchContent) {
      if (searchContent) {
        this.searchContent = searchContent.replace(/<[^>]*>/g, "");
        this.showHistory = false;
        this.showHistoryDialog = false;
        this.showLink = false;
        this.showLinkDialog = false;
      }
      if (!this.searchContent) {
        this.searchContent = this.holderText;
      }
      if (this.searchContent.trim()) {
        this.setHistory(this.searchContent);
        if (this.$route.path.endsWith("search-page")) {
          this.$router.push({
            path: "/search-page",
            query: { name: this.searchContent },
          });
        } else {
          window.open("search-page?name=" + this.searchContent);
        }
      } else {
        return;
      }
    },
    async getLinkList() {
      if (!this.searchContent) {
        this.searchHistory.splice(0, this.searchHistory.length);
        if (localStorage.getItem("searchHistory")) {
          localStorage
            .getItem("searchHistory")
            .split(",")
            .forEach((e) => this.searchHistory.push(e));
        }
        if (this.searchHistory && this.searchHistory.length > 0) {
          this.showHistory = true;
        }
        this.showLink = false;
        this.showLinkDialog = false;
        return;
      }
      this.showHistory = false;
      this.showHistoryDialog = false;
      this.showLink = true;
      if (this.oldContent == this.searchContent) {
        return;
      }
      try {
        let { data } = await getAssocationList({
          search: this.searchContent,
        });
        this.linkList.splice(0, this.linkList.length);
        data.list.forEach((e) => this.linkList.push(e));
        this.oldContent = this.searchContent;
      } catch (e) {
        console.log(e);
      }
    },
    changeState() {
      this.showHistory = false;
      this.showLink = false;
    },
    async getHotWords() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.holderText = "";
      } else {
        try {
          let { data } = await getHotWrods();
          this.hotWords = data.hot_search.split(",");
          this.holderText = this.hotWords[0];
        } catch (e) {
          console.log(e);
        }
      }
    },
    setHolderText() {
      if (this.hotWords && this.hotWords.length > 0) {
        if (this.index >= this.hotWords.length) {
          this.index = 0;
          this.holderText = this.hotWords[this.index];
        } else {
          this.holderText = this.hotWords[this.index];
          this.index++;
        }
      }
    },
    initPlaceHolder() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.holderText = "";
      } else {
        this.timer = setInterval(this.setHolderText, 5000);
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.index_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  overflow: visible;
  clear: both;
  line-height: 76px;
  // .ih_left {
  //   margin-right: 80px;
  // }
  .ih_right {
    .search {
      float: left;
      margin-top: 19px;
      margin-right: 100px;
      line-height: 38px;
      ul {
        padding: 0;
        margin: 0;
        list-style: none;
      }
      .search_content {
        position: relative;
        box-sizing: border-box;
        float: left;
        width: 550px;
        height: 38px;
        vertical-align: top;
        background-color: #fff;
        border-bottom: 1px solid #e7e7e7;
        .input_content {
          width: 400px;
          height: 37px;
          padding: 0;
          font-size: 18px;
          color: #b2b2b2;
          vertical-align: top;
          border: 0;
          outline: 0;
          &::placeholder {
            color: #b2b2b2;
          }
          &::-webkit-input-placeholder {
            color: #b2b2b2;
          }
        }
        .search_img {
          padding: 8px 10px;
          vertical-align: top;
        }

        .history_content {
          position: absolute;
          top: 38px;
          left: 0;
          z-index: 10;
          width: 100%;
          height: auto;
          background-color: #fff;
          ul {
            .history_bar {
              margin-top: 10px;
              margin-left: 18px;
              font-size: 16px;
              line-height: 16px;
              color: #a3a2a2;
              span {
                float: right;
                margin-right: 14px;
              }
            }
            .history_item {
              height: 26px;
              margin-top: 10px;
              vertical-align: center;

              .history_text {
                float: left;
                width: 80%;
                padding: 5px 0;
                margin-left: 18px;
                font-size: 16px;
                line-height: 16px;
                color: #333;
                vertical-align: center;
                @include textoverflow(1);
              }
              .el-icon-error {
                float: right;
                padding: 5px 0;
                margin-right: 22px;
                font-size: 16px;
                line-height: 16px;
                color: #e7e7e7;
                vertical-align: center;
              }
              &:hover {
                background-color: rgba(237, 235, 235, 0.39);
              }
            }
            .suggestion_item {
              height: 26px;
              margin-top: 10px;
              .suggestion_text {
                width: 94%;
                padding: 5px 0;
                margin: 5px 18px 0 18px;
                font-size: 16px;
                line-height: 16px;
                color: #333;
                @include textoverflow(1);
                ::v-deep span {
                  color: #3a70dc;
                }
              }
              &:hover {
                background-color: rgba(237, 235, 235, 0.39);
              }
            }
            li:last-child {
              margin-bottom: 10px;
            }
            li {
              font-weight: 400;
            }
          }
        }
      }
      .search_button {
        float: right;
        width: 81px;
        height: 38px;
        padding: 0;
        font-size: 20px;
        color: #fff;
        vertical-align: top;
        background-color: #92a0ff;
        border: none;
        outline: none;
      }
    }
    .outer_link {
      float: right;

      .divider {
        display: inline-block;
        width: 1px;
        height: 14px;
        margin: 0 24px;
        background-color: #fff;
      }
      a {
        font-size: 20px;
        font-weight: 400;
        color: #fff;
      }
    }
  }
}
</style>
